import { render, staticRenderFns } from "./Aftercare.vue?vue&type=template&id=0cf55328"
import script from "./Aftercare.vue?vue&type=script&lang=js"
export * from "./Aftercare.vue?vue&type=script&lang=js"
import style0 from "./Aftercare.vue?vue&type=style&index=0&id=0cf55328&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports